module.exports = __webpack_public_path__ + "static/media/Stephen Parodi MD.20ca3d43.png";